import { render } from "./serviceDetailModel.vue?vue&type=template&id=13fe4296&scoped=true"
import script from "./serviceDetailModel.vue?vue&type=script&lang=js"
export * from "./serviceDetailModel.vue?vue&type=script&lang=js"

import "./serviceDetailModel.vue?vue&type=style&index=0&id=13fe4296&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13fe4296"]])

export default __exports__